const floorBoundingClientRect = (boundingClientRect) => {
  const { bottom, height, left, right, top, width, x, y } = boundingClientRect

  return {
    bottom: Math.floor(bottom),
    height: Math.floor(height),
    left: Math.floor(left),
    right: Math.floor(right),
    top: Math.floor(top),
    width: Math.floor(width),
    x: Math.floor(x),
    y: Math.floor(y),
  }
}

export const updatePosition = ({ _wrap, _menu, props, state, updateState }) => {
  if (_wrap == null || _menu == null) {
    return
  }

  const allowedDiff = 2

  const menuStyle = window.getComputedStyle(_menu)
  const menuMarginTop = parseInt(menuStyle.marginTop)

  const wrapOffsetLeft = Math.floor(_wrap.offsetLeft)
  const wrapOffsetWidth = Math.floor(_wrap.offsetWidth)
  const menuOffsetLeft = Math.floor(_menu.offsetLeft)
  const menuOffsetWidth = Math.floor(_menu.offsetWidth)

  let wrapBounds = floorBoundingClientRect(_wrap.getBoundingClientRect())
  let menuBounds = floorBoundingClientRect(_menu.getBoundingClientRect())

  if (props.doSyncWidth && Math.abs(wrapBounds.width - menuBounds.width) > allowedDiff) {
    let maxWidth = Math.max(wrapBounds.width, menuBounds.width)

    if (
      state.syncWidth != null &&
      (state.syncWidth - wrapBounds.width > allowedDiff ||
        state.syncWidth - menuBounds.width > allowedDiff)
    ) {
      maxWidth = Math.min(wrapBounds.width, menuBounds.width)
    }
    updateState({
      syncWidth: maxWidth,
    })
  }

  if (props.doSyncMinWidth && wrapBounds.width - menuBounds.width > allowedDiff) {
    updateState({
      menuMinWidth: wrapBounds.width,
    })
  }

  if (
    props.doAlignMenu &&
    !props.doAlignMenuRight &&
    Math.abs(wrapOffsetLeft - menuOffsetLeft) > allowedDiff
  ) {
    updateState({
      menuOffsetLeft: wrapOffsetLeft,
    })
  }

  if (
    props.doAlignMenu &&
    props.doAlignMenuRight &&
    Math.abs(wrapOffsetLeft + wrapOffsetWidth - (menuOffsetLeft + menuOffsetWidth)) > allowedDiff
  ) {
    updateState({
      menuOffsetLeft: wrapOffsetLeft + wrapOffsetWidth - menuOffsetWidth,
    })
  }

  if (
    props.doAlignMenu &&
    props.doAlignMenuTop &&
    Math.abs(menuBounds.top - menuMarginTop - (wrapBounds.top + wrapBounds.height)) > allowedDiff
  ) {
    updateState({
      menuOffsetTop: wrapBounds.top + wrapBounds.height,
    })
  }
}
